import { put, call, takeLatest } from "redux-saga/effects";
import TenantActions, { TenantTypes } from "../reducers/TenantRedux";
import Requester from "common/network/http/Request";
import endpoints from "configs/endpoints.js";
import env from "environment";

function* handleFetchCurrentTenant() {
  const response = yield call(
    Requester.get.bind(Requester),
    endpoints.tenant.settings,
  );

  if (response && response.status < 400) {
    if (response.data.id) {
      yield put(TenantActions.setCurrentTenant(response.data));
    } else {
      window.location.href = `https://${env.REACT_APP_STANDALONE_DOMAIN}`;
    }
  }
}

export default function* () {
  return [
    yield takeLatest(TenantTypes.FETCH_CURRENT_TENANT, handleFetchCurrentTenant),
  ];
}
